import { createServerFn } from '@tanstack/react-start'
import type { AppointmentEntity } from '@/components/appointment/AppointmentReschedule.tsx'
import type { WvcHolidayEntity } from '@/interfaces'
import type { AppointmentFormType } from '@/components/appointment/AppointmentForm.tsx'
import { api } from '@/lib/connectivity.ts'

export const getHolidays = createServerFn({
	method: 'GET',
	response: 'data',
}).handler(async () => await api.get('/holidays').then(({ data }) => data.body))

export const getAppointment = createServerFn({ method: 'GET', response: 'data' })
	.validator((data: { id: string }) => data)
	.handler(
		async ({ data: { id } }) =>
			await api.get<{ appointment: AppointmentEntity; holidays: Array<WvcHolidayEntity> }>(`appointment/${id}`).then(({ data }) => data.body),
	)

export const getExistingAppointments = createServerFn({
	method: 'GET',
	response: 'data',
})
	.validator((data: { date: string }) => data)
	.handler(
		async ({ data: { date } }) =>
			await api
				.get<Record<'Fort Lauderdale' | 'Fort Pierce' | 'Riviera Beach' | 'Jacksonville', Array<string>>>(`/appointment/existing/${date}`)
				.then(({ data }) => data.body),
	)
export const createAppointment = createServerFn({
	method: 'POST',
	response: 'data',
})
	.validator((data: { appointment: AppointmentFormType }) => data)
	.handler(async ({ data: { appointment } }) => await api.post<AppointmentEntity>('/appointment', appointment).then(({ data }) => data))

export const rescheduleAppointment = createServerFn({
	method: 'POST',
	response: 'data',
})
	.validator((data: { appointment: Pick<AppointmentFormType, 'slot' | 'date'> & { id: string } }) => data)
	.handler(
		async ({
			data: {
				appointment: { id, ...appointment },
			},
		}) => await api.post<AppointmentEntity>(`/api/appointment/reschedule/${id}`, appointment).then(({ data }) => data),
	)

export const cancelAppointment = createServerFn({
	method: 'POST',
	response: 'data',
})
	.validator((data: { id: string }) => data)
	.handler(async ({ data: { id } }) => await api.post<AppointmentEntity>(`/appointment/cancel/${id}`).then(({ data }) => data))
